<!--
 * @Date: 2021-05-19 10:43:36
-->
<template>
  <div class="syailaHealth-wrap">
    <div class="page1-wrap">
      <div class="w">
        <div class="title">
          <span class="title-a">{{$t('syailaHealth.page1Title1')}}</span>
          <span class="title-b">{{$t('syailaHealth.page1Title2')}}</span>
        </div>
      </div>
    </div>
    <div class="page2-wrap">
      <div class="w">
        <div class="title">
          <span>{{$t('syailaHealth.page2Text1')}}</span>
          <span>{{$t('syailaHealth.page2Text2')}}</span>
        </div>
        <div class="second-box">
          <div class="box-wrap ">
            <div class="box-item box1"></div>
            <span>{{$t('syailaHealth.page2Text3')}}</span>
          </div>
          <div class="box-wrap ">
            <div class="box-item box2"></div>
            <span>{{$t('syailaHealth.page2Text4')}}</span>
          </div>
          <div class="box-wrap ">
            <div class="box-item box3"></div>
            <span>{{$t('syailaHealth.page2Text5')}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="page3-wrap">
      <div class="w">
        <div class="phase-wrap">
          <div class="left-title">
            <span class="span-a">{{$t('syailaHealth.page2Text6')}}</span>
            <span class="span-b"><i class="iconfont icon-yongyoujichufuwuxiang"></i>{{$t('syailaHealth.page2Text7')}}</span>
            <span class="span-b"><i class="iconfont icon-yongyoujichufuwuxiang"></i>{{$t('syailaHealth.page2Text8')}}</span>
          </div>
        </div>
        <div class="friends-wrap">
          <div class="left-title">
            <span v-html="$t('syailaHealth.page2Text9')"></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name:"syailaHealth",
  metaInfo() {
    return {
      title: this.getSeoData.title && this.getSeoData.title,
      meta: [
        {
          name: "keyWords",
          content: this.getSeoData["syaila-health"] && this.getSeoData["syaila-health"].content,
        },
        {
          name: "description",
          content: this.getSeoData["syaila-health"] && this.getSeoData["syaila-health"].description,
        },
      ],
    };
  },
  data() {
    return {

    }
  }
}
</script>

<style lang="scss" scoped>
 @import "syailaHealth.scss";
</style>